import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=8da0abfe&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JobDetail.vue?vue&type=style&index=1&id=8da0abfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0abfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VList,VListItem,VListItemTitle,VMenu,VRow,VSelect,VSkeletonLoader,VTextField})
